import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/MainLogo.png'
import _imports_1 from '@/assets/images/ContecLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-24b6112a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "main_logo",
  src: _imports_0,
  alt: "mainLogo"
}
const _hoisted_3 = {
  key: 0,
  class: "logo",
  src: _imports_1,
  alt: "Contec_Logo"
}
const _hoisted_4 = {
  key: 0,
  class: "orbit_spinner_wrap"
}

import { storeToRefs } from 'pinia';
import { OrbitSpinner } from 'epic-spinners';

import FailedModal from '@/components/common/modal/FailedModal.vue';
import ForgotAccountModal from '@/components/common/modal/ForgotAccountModal.vue';
import LicenseModal from '@/components/common/modal/LicenseModal.vue';
import SuccessModal from '@/components/common/modal/SuccessModal.vue';
import SatelliteInfo from '@/components/common/SatelliteInfo.vue';
import BackgroundImages from '@/components/desktop/BackgroundImages.vue';
import HiddenPanel from '@/components/desktop/HiddenPanel.vue';
import LoginedPanel from '@/components/desktop/LoginedPanel.vue';
import LoginPanel from '@/components/desktop/LoginPanel.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import useCommonStore from '@/store/storeCommon';



export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopLayout',
  setup(__props) {

const { isMainLogo, isImageMode, isLoading } = storeToRefs(useCommonStore());
const { imageModeToggle, windowSize, showPanel, showModal } = useCommonStore();

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showMainLogo':
      return isMainLogo.value && !isImageMode.value;
    case 'showContecLogo':
      return !showPanel.isLeftPanel && !isImageMode.value;
    case 'showSatelliteInfo':
      return !showModal.isFail && !showModal.isForgotAccount;
    case 'showImageModeBtn':
      return isImageMode.value && (windowSize.width > 1280 && windowSize.height > 720);
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showMainLogo'))
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showContecLogo'))
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(BackgroundImages),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showSatelliteInfo'))
          ? (_openBlock(), _createBlock(SatelliteInfo, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(LoginPanel),
    _createVNode(LoginedPanel),
    _createVNode(SuccessModal),
    _createVNode(FailedModal),
    _createVNode(ForgotAccountModal),
    _createVNode(LicenseModal),
    _createVNode(HiddenPanel),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showImageModeBtn'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "image_mode_btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(imageModeToggle) && _unref(imageModeToggle)(...args)))
            }, [
              _createElementVNode("span", null, [
                _createVNode(ImageModeSvg)
              ]),
              _createTextVNode(" IMAGE MODE ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(OrbitSpinner), {
                animationDuration: 1200,
                fill: "$color-white"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})